// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./TextArea";
export type { TextAreaProps } from "./TextArea";
